import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable react/require-default-props */
import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';
// Component to create a link to a device or its interface based on the provided props
// Avoid rendering device link to interfaces/tenant if the user is MKP
const DeviceLink = ({
  $app,
  name,
  children,
  snmp_id,
  ...rest
}) => {
  if ($app.isSubtenant) {
    return children || name;
  }
  let path = `/v4/infrastructure/devices/${name}`;
  if (snmp_id) {
    path += `/interfaces/${snmp_id}`;
  }
  return /*#__PURE__*/React.createElement(Link, _extends({
    to: path
  }, rest), children || name);
};
export default inject('$app')(DeviceLink);